(function($) {

	/* one time call if element is in the view of a container element -- return true or false */
    /* container req'd unless it's offsets are passed in the options prop */

    $.fn.inView = function(container, options) {

        var $container,
            settings = {
                yOverflow: false, //if overflow, take the scrollbar width into account
                xOverflow: false,
                scrollBarWidth: 0,
                threshold: 0
            };

        container && ($container = container.jquery ? container : $(container));
        options && $.extend(settings, options);

        var containerOffsets = settings.containerOffsets 
                ? settings.containerOffsets /* eg for lazy load */
                : $container.getOffsets(),
            elementOffsets = $(this).getOffsets();

        //adjust container offset width and height if have overflow -- not using client height so can support IE8
        settings.yOverflow && (containerOffsets.height -= settings.scrollBarWidth);
        settings.xOverflow && (containerOffsets.width -= settings.scrollBarWidth);

        if (aboveTheTop(containerOffsets, elementOffsets, settings) ||
            leftOfBegin(containerOffsets, elementOffsets, settings)) {
            return false;
        } else if ( !belowTheFold(containerOffsets, elementOffsets, settings) &&
            !rightOfFold(containerOffsets, elementOffsets, settings)) {
            return true;
        } else {
            return false;
        }

        function belowTheFold(containerOffsets, elementOffsets, settings) {
            var fold = containerOffsets.top + containerOffsets.height;
            return fold <= elementOffsets.top - settings.threshold;
        }

        function rightOfFold(containerOffsets, elementOffsets, settings) {
            var fold = containerOffsets.left + containerOffsets.width;
            return fold <= elementOffsets.left - settings.threshold;
        }

        function aboveTheTop(containerOffsets, elementOffsets, settings) {
            var fold = containerOffsets.top;
            return fold >= elementOffsets.top + settings.threshold + elementOffsets.height;
        }

        function leftOfBegin(containerOffsets, elementOffsets, settings) {
            var fold = containerOffsets.left;
            return fold >= elementOffsets.left + settings.threshold + elementOffsets.width;
        }
    };

})(jQuery);


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/plugin/jquery.inView.js
 ** module id = 459
 ** module chunks = 0
 **/